import store from '@/store';

export const isUserAuthenticated = function isUserAuthenticated() {
  const { isAuthenticated } = store.state.auth;
  return isAuthenticated;
};

export const onMaintenance = function onMaintenance() {
  return store.state.auth.maintenance_mode;
};

export const isPathValid = function isPathValid(to) {
  const path = to.path.split('/');
  return (store.state.menu.pathList[`/${path[1]}`] || `/${path[1]}` === '/home' || `/${path[1]}/${path[2]}`);
};
